import { forwardRef, type ReactNode } from 'react';
import cx from 'classnames';

import styles from './ItemContent.module.scss';

interface ItemContentProps {
  className?: string;
  item: {
    id: string;
    renderItem: () => ReactNode;
  };
  'data-testid'?: string;
}

/**
 * A menu entry that is plain content, not an action. It is not a menu item: it takes no focus, the
 * arrow keys skip it, and a click on it does not close the menu. MUI passes `tabIndex`, `autoFocus`
 * and `onClick` to its children, so this component takes none of them.
 */
export const ItemContent = forwardRef<HTMLLIElement, ItemContentProps>(
  ({ className, item, 'data-testid': testId }, ref) => (
    <li
      className={cx(styles.root, className)}
      ref={ref}
      id={item.id}
      data-testid={testId ?? `ContextMenu__Item__${item.id}`}
    >
      <div className={styles.header}>{item.renderItem()}</div>
    </li>
  )
);

ItemContent.displayName = 'ItemContent';
